import React, { useEffect, useState, useRef } from "react";
import { useMemo } from "react";

import {
  TooltipBubble,
  TooltipMessage,
  TooltipTrigger,
  TooltipContainer,
} from "./styles";

type TooltipProps = {
  message: string;
  position?: "top" | "bottom" | "left" | "right";
  width?: number;
  children: React.ReactNode;
  className?: string;
  minWidth?: number;
  maxWidth?: number;
  left?: string;
};

export const Tooltip = ({
  message,
  position,
  width,
  children,
  className,
  minWidth,
  maxWidth,
  left,
}: TooltipProps) => {
  const [displayTooltip, setDisplayTooltip] = useState(false);
  const [offsetHeight, setOffsetHeight] = useState(0);

  /**
   * Reference to the children component to track width and height
   */
  const nodeTrigger = useRef<HTMLDivElement>(null);

  const bubbleWidth = useMemo(() => {
    if (nodeTrigger.current) {
      const rect = nodeTrigger.current.getBoundingClientRect();
      return window.innerWidth - rect.right + rect.width;
    }
    return 0;
  }, [nodeTrigger.current]);

  useEffect(() => {
    if (nodeTrigger.current) {
      const offsetHeight = nodeTrigger.current.offsetHeight;
      setOffsetHeight(offsetHeight);
    }
  }, [nodeTrigger]);

  return (
    <TooltipContainer
      onMouseLeave={() => setDisplayTooltip(false)}
      className={`tooltip-container ${className || ""}`}>
      {displayTooltip ? (
        <TooltipBubble
          className="tooltip-bubble"
          position={position}
          offsetHeight={offsetHeight}
          minWidth={minWidth}
          maxWidth={maxWidth}
          width={width}
          bubbleWidth={bubbleWidth}
          left={left}>
          <TooltipMessage>{message}</TooltipMessage>
        </TooltipBubble>
      ) : null}
      <TooltipTrigger
        onMouseOver={() => setDisplayTooltip(true)}
        ref={nodeTrigger}>
        {children}
      </TooltipTrigger>
    </TooltipContainer>
  );
};
